import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {RootState} from '@/store';

export interface FormMakerPublishState {
  isSharedInTeam: boolean;
}

const initialState: FormMakerPublishState = {
  isSharedInTeam: false,
};

const formMakerPublishStateSlice = createSlice({
  name: 'formMakerPublishState',
  initialState,
  reducers: {
    setFormMakerPublishState: (_state, action: PayloadAction<FormMakerPublishState>) => {
      return action.payload;
    },
    setIsSharedInTeam: (state, action: PayloadAction<boolean>) => {
      state.isSharedInTeam = action.payload;
    },
  },
});

export const {setFormMakerPublishState, setIsSharedInTeam} = formMakerPublishStateSlice.actions;

export const formMakerPublishStateReducer = formMakerPublishStateSlice.reducer;

export const selectFormMakerPublishState = (state: RootState): FormMakerPublishState => state.formMakerPublishState;
